import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Downtown St. Louis needed",
      "Ideal for St. Charles County professionals with international business",
      "Perfect for O'Fallon families with upcoming European vacations",
      "Great for last-minute trips booked from STL",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at O'Fallon post offices",
      "Good for planned international trips from STL",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at O'Fallon USPS",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: St. Louis — ~30 mi, 35–50 min drive",
      "NPIC appointment required before traveling to St. Louis",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function OFallonProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="O'Fallon"
      introText="O'Fallon residents — St. Charles County professionals commuting into the metro area, families planning summer vacations to Europe from STL, and local travelers with international trips on the horizon — have several options for getting a passport fast. Here is how they compare, and why most O'Fallon residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive to Downtown St. Louis."
      options={options}
      emergencyDescription="O'Fallon does not have its own regional passport agency. The closest is St. Louis — about 30 miles east on I-70, typically 35–50 minutes but often longer with St. Louis metro traffic. For a St. Charles County professional with a last-minute business trip or a family with an upcoming international flight from STL, that round trip is a half-day commitment."
      disclaimerText="*Processing speed depends on eligibility and documentation. O'Fallon does not have a regional passport agency — the closest is St. Louis. Not all applicants qualify for Regional Agency Processing."
    />
  );
}